import littlehouse from './littlehouse.jpg'

export default function Home() {
    return (<img src={littlehouse} alt="LittleHouse" className="LHImage" />);
}